<template>
    <paper class="receiptManage">
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="回单签收" name="Sign">
                <Sign/>
            </el-tab-pane>
            <el-tab-pane label="回单移交" name="TrueOver">
                <TrueOver/>
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import Sign from './sign/Index';
import TrueOver from './trueOver/Index';
export default {
    name: 'receiptManage',
    components: { paper, Sign, TrueOver },
    data() {
        return {
            activeName: 'Sign'
        };
    },
    methods: {
        tabClick(val) {
            const btnVal = {
                Sign: '订单管理-大物流,回单管理,回单签收,回单签收-查询',
                TrueOver: '订单管理-大物流,回单管理,回单移交,回单移交-查询'
            };
            window.bigDataConfig = { 'bigData-btn-search': btnVal[val.name] };
        }
    },
    activated () {
        this.tabClick({ name: this.activeName });
    }
};
</script>
<style lang="less">
.receiptManage{
    .tablePage{
        .el-table {
            min-height: calc(~ '100vh - 223px') !important;
            max-height: calc(~ '100vh - 223px') !important;
        }
    }
}
</style>